export function removeSpaces(str) {
    return str.replace(/\s/g, "");
}

export function isEmpty(obj) {
    if (!obj) {
        return true;
    }
    for (let prop in obj) {
        if (obj.hasOwnProperty(prop))
            return false;
    }

    return JSON.stringify(obj) === JSON.stringify({});
}

export function getEnvironment(type, epaas) {
    switch (type) {
        case  "aexp" :
            switch (epaas) {
                case "-dev":
                    return "e1sl";
                case "-qa":
                    return "e2sl";
                default :
                    return "e3sl";
            }
        case  "americanexpress" :
            switch (epaas) {
                case "-dev":
                    return "e1";
                case "-qa":
                    return "e2";
                default :
                    return "e3";
            }
        default :
            switch (epaas) {
                case "-dev":
                    return "e1";
                case "-qa":
                    return "e2";
                default :
                    return "e3";
            }
    }
}

export function getEnvRoute(route, zone) {
    switch (route) {
        case "blue":
            switch (zone) {
                case "gdha":
                    return "";
                case "ipc1":
                    return "1";
                case "ipc2-1":
                    return "-r1";
                case "ipc2-2":
                    return "-r2";
                default :
                    return "";
            }
        case "green":
            switch (zone) {
                case "ipc1":
                    return "-green1";
                case "ipc2-1":
                    return "-green-r1";
                case "ipc2-2":
                    return "-green-r2";
                default :
                    return "-green1";
            }
    }

}

function getSdkUrl(env) {
    switch (env) {
        case "e1":
            return "https://cdaas-dev.americanexpress.com/akamai/remotecommerce/scripts/amexSDK-dev-1.0.0.js";
        case "e2":
            return "https://qwww.aexp-static.com/akamai/remotecommerce/scripts/amexSDK-1.0.0.js";
        case "e3":
            return "https://www.aexp-static.com/cdaas/remotecommerce/scripts/amexSDK-1.0.0.js";
        case "e1sl":
            return "https://cdaas-dev.aexp.com/remotecommerce/scripts/amexSDK-dev-1.0.0.js";
        case "e2sl":
            return "https://cdaas-test.aexp.com/remotecommerce/scripts/amexSDK-1.0.0.js";
        case "e3sl":
            return "https://cdaas.aexp.com/remotecommerce/scripts/amexSDK-1.0.0.js";
        default:
            return "https://cdaas-dev.americanexpress.com/akamai/remotecommerce/scripts/amexSDK-dev-1.0.0.js";
    }
}

function getSdkSKUrl(env) {
    switch (env) {
        case "e1":
            return "https://cdaas-dev.americanexpress.com/akamai/remotecommerce/scripts/amexSDKSK-dev-1.0.0.js";
        case "e2":
            return "https://qwww.aexp-static.com/akamai/remotecommerce/scripts/amexSDKSK-1.0.0.js";
        case "e3":
            return "https://www.aexp-static.com/cdaas/remotecommerce/scripts/amexSDKSK-1.0.0.js";
        case "e1sl":
            return "https://cdaas-dev.aexp.com/remotecommerce/scripts/amexSDKSK-dev-1.0.0.js";
        case "e2sl":
            return "https://cdaas-test.aexp.com/remotecommerce/scripts/amexSDKSK-1.0.0.js";
        case "e3sl":
            return "https://cdaas.aexp.com/remotecommerce/scripts/amexSDKSK-1.0.0.js";
        default:
            return "https://cdaas-dev.americanexpress.com/akamai/remotecommerce/scripts/amexSDKsk-dev-1.0.0.js";
    }
}

export function getDcfUrl(env?: string) {
    switch (env) {
        case "local":
            return "https://localhost:3000";
        case "e1":
            return "https://srcdcf-dev.americanexpress.com";
        case "e2":
            return "https://srcdcf-qa.americanexpress.com";
        case "e3":
            return "https://srcdcf.americanexpress.com";
        case "e3g":
            return "https://srcdcf-green1.americanexpress.com";
        case "e1sl":
            return "https://srcweb-dev.aexp.com";
        case "e2sl":
            return "https://srcweb-qa.aexp.com";
        case "e3sl":
            return "https://srcweb.aexp.com";
        default:
            return "https://srcdcf-dev.americanexpress.com";
    }
}

export function sdkUrls(env, sandbox, route, zone, advancedEnv) {
    console.log("env");
    let epaas = null;
    if (advancedEnv) {
        if (env === "e2" || env === "e2sl") {
            epaas = route === "blue" ? "-qa" : "-green-qa";
        } else {
            epaas = getEnvRoute(route, zone);
        }
    }
    if (IS_LOCALHOST) {
        let url = `https://localhost:8080/lib/amexSDK${window.location.href.includes("srcsafekeyservices") ? 'SK' : ''}-dev-1.0.0.js`; //tls script
        if (advancedEnv) {
            url = url + `?env=${epaas}`;
        }
        return url;
    }
        if (window.location.href.includes("srcsafekeyservices")) {
            let url = getSdkSKUrl(env);
            if (sandbox) {
                url = url.replace("amexSDKSK", "amexSDKSK-sandbox");
            } else if (advancedEnv) {
                url = url + `?env=${epaas}`;
            }
            return url;
        } else {

        let url = getSdkUrl(env);
        if (sandbox) {
            url = url.replace("amexSDK", "amexSDK-sandbox");
        } else if (advancedEnv) {
            url = url + `?env=${epaas}`;
        }
        return url;
        }
        }
   



function getURLs() {
    const domain: any = {};
    let hostname = "";
    hostname = window.location.hostname;
    const prefix = hostname.split(".")[0];
    const env = prefix.split("-");
    // set default to dev unless amex site
    let domainType = hostname.split(".")[1];

    // Do not edit below line to -dev as this will effect the env buttons in PROD
    let epass = "";
    if (!domainType) {
        epass = "";
    }
    if (env.length > 1) {
        epass = `-${env[1]}`;
    }
    //epass = "-qa";  //uncomment for local
    domain.type = domainType;
    domain.epass = epass;
    domain.keys = `https://openid${epass}.americanexpress.com`;
    domain.log = `https://srcservicing-qa.americanexpress.com`;
    return domain;
}

export function generateUUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0, // tslint:disable-line
            v = c === "x" ? r : (r & 0x3) | 0x8; // tslint:disable-line
        return v.toString(16);
    });
}

export function postMessageToSRCi(data: any) {
    try {
        let postData = (typeof data === "string") ? data : JSON.stringify(data);
        if (window.opener) {
            window.opener.postMessage(postData, "*");
        } else if (window.parent) {
            window.parent.postMessage(postData, "*");
        }
    } catch (e) {
        console.log("Post message failed " + e);
    }

}

const Domain = getURLs();
export const DOMAIN_ENV = Domain.epass;
export const DOMAIN_TYPE = Domain.type;
export const BASE_KEY_URL = Domain.keys;
export const BASE_SKAUTHSERVICE_URL_TOKEN = `https://dpsafekeyauthservice-qa.aexp.com`;

export const REPORTING_URL = Domain.log;
export const DCF_LOCAL_URL = "https://localhost:3000";
export const IS_LOCALHOST = (process.env.NODE_ENV !== "production");